import { createContext, useContext } from 'react';
import { geminiEnterpriseAgentsService } from '../services/gemini-enterprise/geminiEnterpriseAgentsService';

/**
 * Context to inject agent-platform service layer into shared page components.
 * Defaults to geminiEnterpriseAgentsService so existing Gemini Enterprise pages
 * work without changes. Copilot Studio pages override via provider.
 */
const AgentServiceContext = createContext(geminiEnterpriseAgentsService);

export const AgentServiceProvider = AgentServiceContext.Provider;

export function useAgentService() {
  return useContext(AgentServiceContext);
}

export default AgentServiceContext;
